<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button autoHide="false"></ion-menu-button>
      <ion-back-button defaultHref="/call/dashboard" text="" icon="chevron-back"></ion-back-button>
    </ion-buttons>
    <ion-title>Review</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="form-container">
    <form [formGroup]="ratingForm" class="ion-padding container-form selected">
      <ion-item>
        <p>Please review your reservation at:</p>
        <p *ngIf="reserva && reserva.restaurante">{{ reserva.restaurante.nome }} - {{ reserva.dataCadastro | date:
          "MM/dd/yyyy h:mm a"}} for {{ reserva.quantidadePessoas }} people</p>
        <ion-label position="stacked" style="font-size: 16px !important">Did you go?</ion-label>
        <ion-radio-group value="''" (ionChange)="wentToReservation = $event" style="display: flex; padding-top: 5px;">
          <ion-item>
            <ion-label>Yes</ion-label>
            <ion-radio slot="start" value="true"></ion-radio>
          </ion-item>
          <ion-item>
            <ion-label>No</ion-label>
            <ion-radio slot="start" value="false"></ion-radio>
          </ion-item>
        </ion-radio-group>
      </ion-item>
      <ion-item>
        <ion-label position="stacked" style="font-size: 16px !important">Your rating</ion-label>
        <star-rating *ngIf="enableRating" formControlName="pontuacao" [id]="'pontuacao'" #myForm
          [disabled]="disableRating">
        </star-rating>
      </ion-item>
      <ion-button [disabled]="ratingForm.invalid" class="ion-margin-top" color="primary" expand="full" shape="round"
        (click)="sendReview()">
        Send review</ion-button>
    </form>
  </div>
</ion-content>